export type { HowToGetSectionProps } from "./how-to-get-section";
export { HowToGetSection } from "./how-to-get-section";
